enum AgentStatusCodes {
  Success = 0,
  ServerError = 1,
  SessionDoesNotExist = 2,
  InvalidCredentials = 3,
  AdditionalChallengesRequired = 4,
  BadParameterPassedIn = 5,
  NotFound = 6,
  Unauthorized = 7,
  Conflict = 8,
  RateLimited = 9,
  NotReady = 10,
  Timeout = 11,
  InvalidSignature = 12,
  OperationWasAlreadyDone = 13,
  DatabaseDuplicateKey = 14,
  EmailOrPhoneIsNotConfirmed = 15,
  InvalidSessionIdNeedToReauthenticate = 16,
  AttestationFailure = 17,
  FormErrorListIsIncluded = 18,
  RequestDenied = 19,
  ReauthenticationNeeded = 23,
  CompanionError = 10001,
}

export default AgentStatusCodes
